import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";
import { saveCoacheesListQuery } from "@/domains/-session/functions/coacheesListQuery";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {GetWorkspaceCoachees, JourneyId, JourneyName, PersonId, WorkspaceId} from "@/sdk.ts";
import {LocationQueryRaw, RouteLocationRaw, Router, RouteRecordRaw} from "vue-router";

export function getSynthesisRouteRecord(): RouteRecordRaw {
  return {
    name: 'synthesis',
    path: '/workspace/:workspaceId/coachee/:personId/journey/:journeyId/synthesis/:synthesisName',
    component: customAsyncComponent(async () => import('./views/SynthesisView.vue')),
    meta: {
      hasNav: false,
      requiresAuth: true
    },
  }
}

export function getSynthesisRouteLocation(workspaceId: WorkspaceId, personId: PersonId, journeyId: JourneyId, synthesisName: string, query: any): RouteLocationRaw {
  return {name: 'synthesis', params: {workspaceId, personId, journeyId, synthesisName}, query}
}

export function getSynthesisRouteParams(router: Router): { workspaceId: WorkspaceId; personId: PersonId; journeyId: JourneyId, synthesisName: string} {
  const route = router.currentRoute.value;
  return {
    workspaceId: parseInt(route.params.workspaceId as string, 10),
    personId: route.params.personId as string,
    journeyId: route.params.journeyId as string,
    synthesisName: route.params.synthesisName as string
  }
}